function deepCopy(payload) {
  return JSON.parse(JSON.stringify(payload));
}

export default deepCopy;
